import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import VueCookies from 'vue-cookies';
import VxeUITable from 'vxe-table';
import 'vxe-table/lib/style.css';

const app = createApp(App);
app.use(ElementPlus,{
    locale: zhCn,
  });
app.use(router);
app.use(VueCookies);
app.use(VxeUITable);


// 设置cookie过期时间为7天
app.config.globalProperties.$cookies.config('7d');
app.mount("#app");
